import React from "react";

type MenuCloseButtonProps = {
  onClick: () => void;
};

const MenuCloseButton = ({ onClick }: MenuCloseButtonProps) => {
  return (
    <button onClick={onClick} className="absolute top-4 right-4 text-wood-dark">
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M6 18L18 6M6 6l12 12"
        ></path>
      </svg>
    </button>
  );
};

export default MenuCloseButton;
